import { render } from "./P061.vue?vue&type=template&id=5d9911e2&scoped=true"
import script from "./P061.vue?vue&type=script&lang=js"
export * from "./P061.vue?vue&type=script&lang=js"

import "./P061.vue?vue&type=style&index=0&id=5d9911e2&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9911e2"]])

export default __exports__